import { motion } from "framer-motion";
import { useState } from "react";
import { trackEvent } from "@/lib/analytics";

const socials = [
  { label: "Email", value: "basupreeti1007@gmail.com", href: "mailto:basupreeti1007@gmail.com" },
  { label: "LinkedIn", value: "in/preeti-basu", href: "https://www.linkedin.com/in/preeti-basu-671967a3/" },
  { label: "Twitter / X", value: "@PreetiBasu7", href: "https://x.com/PreetiBasu7" },
];

const Contact = () => {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    navigator.clipboard.writeText("basupreeti1007@gmail.com");
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
    trackEvent("contact_click", { channel: "copy_email" });
  };

  return (
    <section
      id="contact"
      className="relative py-28 md:py-44 overflow-hidden border-t border-[var(--bone)]/10"
      data-testid="contact-section"
    >
      {/* background type */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="font-serif italic text-[32vw] leading-none text-white/[0.028] select-none whitespace-nowrap">
          hello
        </div>
      </div>

      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-20%" }}
          transition={{ duration: 0.9 }}
          className="max-w-4xl"
        >
          <div className="font-mono text-[11px] tracking-[0.28em] uppercase text-[var(--copper)] mb-6">
            [ Chapter VI — Contact ]
          </div>
          <h2 className="font-serif text-6xl md:text-[9vw] leading-[0.88] text-[var(--bone)]">
            Have a
            <br />
            <span className="italic text-[var(--copper)]">payment problem</span>
            <br />
            worth solving?
          </h2>

          <p className="mt-10 text-[var(--bone)]/70 text-lg md:text-xl font-light max-w-2xl leading-relaxed">
            I'm open to consulting engagements, fractional PM roles, and full-time
            opportunities in payments, wallets & AI infra. If it moves money — I
            want to hear about it.
          </p>

          <div className="mt-14 flex flex-wrap gap-4">
            <a
              href="mailto:basupreeti1007@gmail.com"
              data-testid="contact-cta-email"
              onClick={() => trackEvent("contact_click", { channel: "email_cta" })}
              className="group inline-flex items-center gap-4 px-6 py-4 rounded-full bg-[var(--copper)] text-[var(--ink)] hover:bg-[var(--bone)] transition-colors"
            >
              <span className="font-mono text-[11px] tracking-[0.24em] uppercase">
                Start an email
              </span>
              <span className="w-6 h-6 rounded-full bg-[var(--ink)] text-[var(--copper)] flex items-center justify-center group-hover:rotate-45 transition-transform">
                →
              </span>
            </a>
            <button
              onClick={copy}
              data-testid="contact-copy-email"
              className="inline-flex items-center gap-4 px-6 py-4 rounded-full border border-[var(--bone)]/25 hover:border-[var(--copper)] hover:text-[var(--copper)] transition-colors"
            >
              <span className="font-mono text-[11px] tracking-[0.24em] uppercase">
                {copied ? "✓ Copied" : "Copy address"}
              </span>
            </button>
          </div>

          <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-6 pt-10 border-t border-[var(--bone)]/10">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target={s.href.startsWith("http") ? "_blank" : undefined}
                rel="noopener noreferrer"
                data-testid={`social-${s.label.toLowerCase().replace(/[^a-z]/g, "")}`}
                onClick={() =>
                  trackEvent("contact_click", {
                    channel: s.label.toLowerCase().replace(/[^a-z]/g, "_"),
                  })
                }
                className="group block"
              >
                <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-[var(--bone-dim)] mb-2">
                  {s.label} ↗
                </div>
                <div className="font-serif text-2xl md:text-3xl italic text-[var(--bone)] group-hover:text-[var(--copper)] transition-colors link-line">
                  {s.value}
                </div>
              </a>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
